import React from "react";
import { ShieldCheck, FlaskConical, Truck, Lock, FileCheck } from "lucide-react";

const ITEMS = [
  { icon: FlaskConical, t: "3rd-Party HPLC Tested", d: ">99% verified purity" },
  { icon: FileCheck, t: "COA on Every Batch", d: "Lab report on file" },
  { icon: ShieldCheck, t: "Made in the USA", d: "FDA-registered facility" },
  { icon: Truck, t: "Discreet & Tracked", d: "Ships in 24 hours" },
  { icon: Lock, t: "256-bit SSL Checkout", d: "Stripe-encrypted" },
];

const TrustBar = ({ compact = false }) => (
  <div
    className={`grid grid-cols-2 md:grid-cols-5 gap-px bg-gray-200 ${compact ? "" : "border border-gray-200"}`}
    data-testid="trust-bar"
  >
    {ITEMS.map(({ icon: Icon, t, d }) => (
      <div key={t} className="bg-white px-4 py-5 text-center">
        <Icon className="h-4 w-4 text-[#b91c1c] mx-auto mb-2" />
        <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#0a0a0a]">{t}</div>
        {!compact && <div className="text-[11px] text-gray-500 mt-1 font-light">{d}</div>}
      </div>
    ))}
  </div>
);

export default TrustBar;
